const normalizeSearchValue = (value) =>
  value.toLowerCase().replace(/\s+/g, " ").trim();

const escapeSelectorString = (value) =>
  value.replace(/\\/g, "\\\\").replace(/"/g, '\\"');

const getResultsLabel = (count, singularLabel, pluralLabel) =>
  count === 1 ? `${count} ${singularLabel}` : `${count} ${pluralLabel}`;

const initializeSchoolListFilter = (container) => {
  const input = container.querySelector(".hoas-list-all-schools__filter-input");
  const cityFilter = container.querySelector(
    ".hoas-list-all-schools__city-filter",
  );
  const resultsCount = container.querySelector("[data-results-count]");
  const rows = container.querySelectorAll("tbody tr[data-row-content]");

  if (!input || rows.length === 0) {
    return;
  }

  const styleElement = document.createElement("style");
  styleElement.setAttribute("data-school-list-filter", "");
  container.appendChild(styleElement);

  const getVisibleRows = (query) => {
    if (query === "") {
      return Array.from(rows);
    }

    return Array.from(rows).filter((row) => {
      const rowContent = row.getAttribute("data-row-content") || "";

      return rowContent.includes(query);
    });
  };

  const updateRowParity = (visibleRows) => {
    rows.forEach((row) => {
      row.classList.remove("is-odd", "is-even");
    });

    visibleRows.forEach((row, index) => {
      row.classList.add(index % 2 === 0 ? "is-odd" : "is-even");
    });
  };

  const updateResultsCount = (visibleRows) => {
    if (!resultsCount) {
      return;
    }

    const singularLabel =
      resultsCount.getAttribute("data-singular-label") || "oppilaitos";
    const pluralLabel =
      resultsCount.getAttribute("data-plural-label") || "oppilaitosta";

    resultsCount.textContent = getResultsLabel(
      visibleRows.length,
      singularLabel,
      pluralLabel,
    );
  };

  const updateFilter = () => {
    const query = normalizeSearchValue(input.value);
    const visibleRows = getVisibleRows(query);

    if (query === "") {
      if (cityFilter) {
        cityFilter.value = "";
      }

      styleElement.textContent = "";
      updateRowParity(visibleRows);
      updateResultsCount(visibleRows);
      return;
    }

    const selectorValue = escapeSelectorString(query);

    styleElement.textContent = `
      .hoas-list-all-schools tbody tr {
        display: none;
      }

      .hoas-list-all-schools tbody tr[data-row-content*="${selectorValue}"] {
        display: grid;
      }
    `;

    updateRowParity(visibleRows);
    updateResultsCount(visibleRows);
  };

  input.addEventListener("input", updateFilter);

  if (cityFilter) {
    cityFilter.addEventListener("change", () => {
      input.value = cityFilter.value;
      updateFilter();
    });
  }

  updateFilter();
};

document
  .querySelectorAll(".hoas-list-all-schools")
  .forEach(initializeSchoolListFilter);
